<template>
  <div class="tradesman-catelist">
    <Row>
        <Col :xs="24" :sm="24">
            <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
                <FormItem>
                   <Button @click="showModel()" type="success" class="f-r">添加分类</Button>
                </FormItem> 
            </Form>
        </Col>
    </Row>
    <Table border :columns="columns1" ref="selection" :data="tablelist" :loading="dataloading"></Table>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus" title="添加分类" @on-ok="createBrand('brandValidate')" :loading="loading">
        <Form :model="cate" ref="brandValidate" :rules="brandValidate" action="javascript:void(0)">
            <FormItem label="分类名称" prop="name">
                <Input v-model="cate.name" placeholder="输入分类名称..."></Input>
            </FormItem>
            <FormItem label="排序" prop="sort">
                <Input v-model="cate.sort" placeholder="输入排序..."></Input>
            </FormItem>
            <FormItem label="状态" label-position="top">
                <RadioGroup v-model="cate.status">
                    <Radio label="1">正常</Radio>
                    <Radio label="0">禁用</Radio>
                </RadioGroup>
            </FormItem>
        </Form>
    </Modal>
     <!-- 修改的弹出 -->
    <Modal v-model="showEditInfoStatus" title="修改分类" @on-ok="updateBrand('brandValidate')" :loading="loading">
        <Form :model="cate" ref="brandValidate" :rules="brandValidate" action="javascript:void(0)">
            <FormItem label="分类名称" prop="name">
                <Input v-model="cate.name" placeholder="输入分类名称..."></Input>
            </FormItem>
            <FormItem label="排序" prop="sort">
                <Input v-model="cate.sort" placeholder="输入排序..."></Input>
            </FormItem>
            <FormItem label="状态" label-position="top">
                <RadioGroup v-model="cate.status">
                    <Radio label="1">正常</Radio>
                    <Radio label="0">禁用</Radio>
                </RadioGroup>
            </FormItem>
        </Form>
    </Modal>
  </div>
</template>

<script>
export default {
    name: 'tradesman-catelist',
    data () {
        return {
            loading: true,
            dataloading: true,
            columns1: [
              {
                  title: '排序',
                  key: 'sort',
                  width:100,
                  fixed: 'left'
              },
              {
                  title: 'Id',
                  key: 'id',
                  width:100,
                  fixed: 'left'
              },
              {
                title: '标题',
                key: 'name',
                fixed: 'left'
              },
              {
                title: '状态',
                key: 'status',
                fixed: 'left'
              },
              {
                title: '操作',
                key: 'action',
                align: 'left',
                render: (h, params) => {
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'info',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    this.showEditInfo(params.row.id)
                                }
                            }
                        }, '修改'),
                        h('Button', {
                            props: {
                                type: 'error',
                                size: 'small'
                            },
                            on: {
                                click: () => {
                                    this.remove(params.row.id)
                                }
                            }
                        }, '删除')
                    ]);
                }
              }
            ],
            tablelist: [],
            cate:{
                name:'',
                sort:'0',
                status:'1',
            },
            formItem:{

            },
            showModalStatus:false,
            showEditInfoStatus:false,
            brandValidate: {
                name: [
                    { required: true, message: '分类名称必须填写', trigger: 'blur' }
                ]
            },
        }
    },
    // 计算
    computed: {
    },
    // 监听
    watch:{
    },
    created: function () {
        // 取数据
        this.getTableList();
    },
    methods:{
        getTableList:function(){
            this.$api.tradesmancate.list().then(res=>{
                this.dataloading = false;
                if(res.code == 200)
                {
                    this.tablelist = res.result.list;
                    for (var i in this.tablelist) {
                    this.tablelist[i].status = this.tablelist[i].status==1?"正常":"禁用";
                }
                    this.$Message.success(res.msg);
                }
            });
            return;
        },
        // 展开添加
        showModel(){
            this.$refs['brandValidate'].resetFields();
            this.showModalStatus = !this.showModalStatus;
        },
        // 添加
        createBrand(name){
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.$api.tradesmancate.create({name:this.cate.name,sort:this.cate.sort,status:this.cate.status}).then(res=>{
                        if(res.code == 200)
                        {
                            this.showModalStatus = !this.showModalStatus;
                            this.cate.name = '';
                            this.getTableList();
                        }
                    });
                    this.loading = false
                    this.$nextTick(() => {this.loading = true;});
                } else {
                    this.$Message.error('请检查输入的信息是否正确！');
                    this.loading = false
                    this.$nextTick(() => {this.loading = true;});
                }
            })
        },
        //展开修改
        showEditInfo:function(index){
            this.cateid = index;
            this.$refs['brandValidate'].resetFields();
            this.showEditInfoStatus = !this.showEditInfoStatus;
            // 取信息
            this.$api.tradesmancate.detail({cateid:index}).then(res=>{
                if(res.code == 200)
                {
                    this.cate = res.result;
                    this.cate.status = this.cate.status.toString();
                    this.$Message.success(res.msg);
                }
                this.loading = false;
                this.$nextTick(() => {this.loading = true;});
            });
        },
        // 修改名称
        updateBrand:function(name){
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.$api.tradesmancate.edit({cateid:this.cateid,name:this.cate.name,sort:this.cate.sort,status:this.cate.status}).then(res=>{
                        if(res.code == 200)
                        {
                            this.$Message.success(res.msg);
                            this.showEditInfoStatus = !this.showEditInfoStatus;
                            this.getTableList();
                        }
                        this.loading = false;
                        this.$nextTick(() => {this.loading = true;});
                        this.showCreateStatus = !this.showCreateStatus;
                    });
                } else {
                    this.$Message.error('请检查输入的信息是否正确！');
                    this.loading = false
                    this.$nextTick(() => {this.loading = true;});
                }
            })
        },
        remove:function(index){
            // 弹出确认框
            this.$Modal.confirm({
                title: '警告',
                content: '<p>此操作不可恢复，三思而后行...</p>',
                onOk: () => {
                    this.$api.tradesmancate.remove({cateid:index}).then(res=>{
                        if(res.code == 200)
                        {
                            this.$Message.success(res.msg);
                            // this.tablelist.splice(index, 1);
                            this.getTableList();
                        }
                    });
                }
            });
        },
    },
}
</script>
